export interface Milestone {
  /** 0-based index of the question just answered when this fires. */
  afterIndex: number;
  text: string;
}

/**
 * Three moments a quiz interrupts itself, placed by length rather than by count
 * so a 6-question quiz gets one and a 20-question quiz gets all three.
 *
 * The last one is the load-bearing one: it fires with a single question left,
 * where quitting costs the player everything they have already answered.
 */
export function milestonesFor(total: number): Milestone[] {
  if (total < 4) return [];

  const last = total - 2;
  const middle = Math.round(total * 0.6) - 1;
  const first = Math.round(total * 0.33) - 1;

  const milestones: Milestone[] = [{ afterIndex: last, text: 'ONE MORE' }];
  if (total >= 6 && middle < last) milestones.push({ afterIndex: middle, text: 'IN THE ZONE' });
  if (total >= 7 && first < middle) milestones.push({ afterIndex: first, text: "LET'S GO" });

  return milestones.sort((a, b) => a.afterIndex - b.afterIndex);
}
